export default __webpack_public_path__ + "static/media/dracoo_banner.59a9b9e6.jpeg";